export enum LoginState {
  LOGINING = 'LOGINING',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGOUT = 'LOGOUT',
  LOGIN_FAILED = 'LOGIN_FAILED',
}
export enum YESNO {
  YES = 1,
  NO = 0,
}

export enum ProductType {
  VEHICLE = 'vehicle',
  ROBOT = 'robot',
  INTEGRATE = 'integrate',
}

export const enum StopType {
  PICKUP = 'PICKUP', // 取货点
  HOME = 'HOME', // HOME点
  STRADDLE = 'STRADDLE', // 跨站停靠点
  LOADING = 'LOADING', // 装载点
}

export enum MrTestStatus {
  PASS = 0, // 测试通过
  NOT_PASS_RETAIN = 1, // 测试不通过(保留)
  LONG_TERM_TEST = 2, //长期测试
  TO_BE_TEST = 3, //待测试
  NOT_PASS_ROLLBACK = 7, // 测试不通过(已回滚)
  NOT_NEED_TO_TEST = 8, // 无需测试
}
export enum MrStatus {
  TO_BE_RELEASE = 'TO_BE_RELEASE', // 待发版
  RELEASED = 'RELEASED', // 已发版
}
export enum MRFocusLevel {
  FOCUS_ON = 'FOCUS_ON',
  NOT_FOCUS_ON = 'NOT_FOCUS_ON',
  NORMAL = 'NORMAL',
}

export enum PageType {
  ADD = 'ADD',
  EDIT = 'EDIT',
  READONLY = 'READONLY',
}

export enum ENABLE {
  ENABLE = 1,
  DISABLE = 0,
}

export enum dropDownKey {
  VEHICLE_TYPE = 'VEHICLE_TYPE', // 车型类型
  VEHICLE_HARDWARE_STATUS = 'VEHICLE_HARDWARE_STATUS', // 车辆生命周期
  VEHICLE_CHECK_STATUS = 'VEHICLE_CHECK_STATUS', // 标定检测状态
  VEHICLE_OWNER_USE_CASE = 'VEHICLE_OWNER_USE_CASE', // 车辆归属方
  VEHICLE_BUSINESS_TYPE = 'VEHICLE_BUSINESS_TYPE', // 车辆类型
  DEFAULT_STATUS = 'DEFAULT_STATUS', // 存在未完成维修单

  // 站点管理
  STATION_USECASE = 'STATION_USE_CASE', // 站点用途
  STATION_TYPE = 'STATION_TYPE', // 站点类型
  STATION_STATUS = 'STATION_STATUS', // 站点状态

  // 停靠点管理
  STOP_TYPE = 'STOP_TYPE_NEW', // 点位类型
  STOP_STATUS = 'STOP_STATUS', // 点位状态

  // 代收点管理
  STOP_COLLECTION_STATUS = 'STOP_COLLECTION_STATUS', // 代收点状态

  // 开机启动异常管理
  VEHICLE_EXCEPTION_DEVICE = 'VEHICLE_EXCEPTION_DEVICE', // 车辆异常设备
  VEHICLE_EXCEPTION_MODULE = 'VEHICLE_EXCEPTION_MODULE', // 车辆异常模块
}

export enum dropDownListKey {
  VEHICLE_TYPE = 'vehicleTypeList', // 车型类型
  VEHICLE_HARDWARE_STATUS = 'vehicleHardwareStatusList', // 车辆生命周期
  VEHICLE_CHECK_STATUS = 'vehicleCheckStatusList', // 标定检测状态
  VEHICLE_OWNER_USE_CASE = 'vehicleOwnerUseCaseList', // 车辆归属方
  VEHICLE_BUSINESS_TYPE = 'vehicleBusinessTypeList', // 车辆类型
  DEFAULT_STATUS = 'defaultStatusList', // 存在未完成维修单

  // 站点管理
  STATION_USECASE = 'stationUseCaseList', // 站点用途
  STATION_TYPE = 'stationTypeList', // 站点类型
  STATION_STATUS = 'stationStatusList', // 站点状态

  // 停靠点管理
  STOP_TYPE = 'stopTypeNewList', // 点位类型
  STOP_STATUS = 'stopStatusList', // 点位状态

  // 代收点管理
  STOP_COLLECTION_STATUS = 'stopCollectionStatusList', // 代收点状态

  // 开机启动异常管理
  VEHICLE_EXCEPTION_DEVICE = 'vehicleExceptionDeviceList', // 车辆异常设备
  VEHICLE_EXCEPTION_MODULE = 'vehicleExceptionModuleList', // 车辆异常模块
}

export enum MapVehicleSource {
  ALLOCATED_VEHICLES = 'ALLOCATED_VEHICLES', // 自有车采图
  OTHER_VEHICLES = 'OTHER_VEHICLES', //借车采图
}

export enum VehicleSupplier {
  JD = 'JD',
  NEOLIX = 'NEOLIX',
  RINO = 'RINO',
}

export enum MapDataType {
  STOP = 'STOP',
  LINE = 'LINE',
  ALL = 'ALL',
}

export enum MapDataSupplierType {
  JD = 'JD',
  NEOLIX = 'NEOLIX',
  ALL = 'ALL',
}

export enum MapRouteApplicateScene {
  // 二程接驳
  GENERAL_TRANSPORT = 'GENERAL_TRANSPORT',
  // 传站
  STATION_TRANSPORT = 'STATION_TRANSPORT',
  // 仓支
  WAREHOUSE_TRANSPORT = 'WAREHOUSE_TRANSPORT',
  // 错分
  MIS_TRANSPORT = 'MIS_TRANSPORT',
  // 冰爽
  COOL_TRANSPORT = 'COOL_TRANSPORT',
}

// 车型标签
export enum VehicleTypeTag {
  JD_4 = 'JD_4', // 4代车
  JD_5 = 'JD_5', // 5代车
  JD_MINI_VAN = 'JD_MINI_VAN', // Mini-Van
  JD_VAN = 'JD_VAN', // Van
  RINO = 'RINO', // 白犀牛通用
  NEOLIX_X3 = 'NEOLIX_X3', // 新石器X3
  NEOLIX_X6 = 'NEOLIX_X6', // 新石器X6
  WERIDE = 'WERIDE', // 文远知行通用
  JD_DATA_COLLECT = 'JD_DATA_COLLECT', // 数采车
}

// 停启用状态
export enum EnableAndDisableStatus {
  ENABLE = 1, // 启用
  DISABLE = 0, // 停用
}

// 停启用状态标签
export const EnableAndDisableStatusLabel = {
  [EnableAndDisableStatus.ENABLE]: '启用',
  [EnableAndDisableStatus.DISABLE]: '停用',
};

// 线路是否上下线状态
export enum LineOnlineStatus {
  ONLINE = 1, // 上线
  OFFLINE = 0, // 下线
}

// 线路是否上下线状态标签
export const LineOnlineStatusLabel = {
  [LineOnlineStatus.ONLINE]: '上线',
  [LineOnlineStatus.OFFLINE]: '下线',
};

// 坐标类型
export enum CoordType {
  /** 百度经纬度坐标 */
  BD09LL = 'bd09ll',
  /** 百度墨卡托坐标 */
  BD09MC = 'bd09mc',
  /** 火星坐标 */
  GCJ02 = 'gcj02',
  /** WGS84坐标 */
  WGS84 = 'wgs84',
}

/* =========================================================================
 * 路测工具相关枚举（路测测评 / 测试项 / 地图设置 / 方案管理 / 缺陷提报配置）
 * 接口 URL 在文档中均为待补充，请配合 src/fetch/business/roadTest*.ts 中的 TBD 占位
 * ========================================================================= */

/** 路测任务类型 */
export enum TaskType {
  COMPREHENSIVE = 'COMPREHENSIVE', // 综合路测
  FATIGUE = 'FATIGUE', // 疲劳路测
}

/** 测评状态（一级 Tab 后的二级 Tab） */
export enum EvaluationStatus {
  EVALUATING = 'EVALUATING', // 测评中
  EVALUATED = 'EVALUATED', // 已测评
  VOIDED = 'VOIDED', // 已作废
}

/** 任务运行状态（任务中 / 已结束） */
export enum RunStatus {
  RUNNING = 'RUNNING', // 任务中
  FINISHED = 'FINISHED', // 已结束
}

/** 测评结果 */
export enum EvaluationResult {
  PASS = 'PASS', // 通过
  FAIL = 'FAIL', // 不通过
}

/** 测试方法 */
export enum TestMethod {
  GATE = 'GATE', // 大门
  SUDDEN_BRAKE = 'SUDDEN_BRAKE', // 急刹车
  JERK = 'JERK', // 急加速/Jerk
  COLLISION = 'COLLISION', // 碰撞
  DRIFT = 'DRIFT', // 偏移
  SLOPE_START = 'SLOPE_START', // 坡道起步
  RUN_RED_LIGHT = 'RUN_RED_LIGHT', // 闯红灯
}

/** 缺陷提报方式 */
export enum ReportType {
  SYSTEM = 'SYSTEM', // 系统触发
  MANUAL = 'MANUAL', // 手动触发
}

/** 操作记录 - 操作类型 */
export enum OperationType {
  CREATE = 'CREATE', // 创建
  PAUSE = 'PAUSE', // 暂停
  RESUME = 'RESUME', // 恢复
  FINISH_VOID = 'FINISH_VOID', // 结束并作废
  SAVE_EVAL = 'SAVE_EVAL', // 保存测评
  SUBMIT_EVAL = 'SUBMIT_EVAL', // 提交测评
  SYSTEM_EVAL = 'SYSTEM_EVAL', // 系统测评
  UPDATE_EVAL = 'UPDATE_EVAL', // 更新测评
  RETEST = 'RETEST', // 重测
}

/** 路测枚举展示文案 */
export const TaskTypeText: Record<TaskType, string> = {
  [TaskType.COMPREHENSIVE]: '综合路测',
  [TaskType.FATIGUE]: '疲劳路测',
};

export const EvaluationStatusText: Record<EvaluationStatus, string> = {
  [EvaluationStatus.EVALUATING]: '测评中',
  [EvaluationStatus.EVALUATED]: '已测评',
  [EvaluationStatus.VOIDED]: '已作废',
};

export const RunStatusText: Record<RunStatus, string> = {
  [RunStatus.RUNNING]: '任务中',
  [RunStatus.FINISHED]: '已结束',
};

export const EvaluationResultText: Record<EvaluationResult, string> = {
  [EvaluationResult.PASS]: '通过',
  [EvaluationResult.FAIL]: '不通过',
};

export const TestMethodText: Record<TestMethod, string> = {
  [TestMethod.GATE]: '过杆：满足闸机杆前停靠',
  [TestMethod.SUDDEN_BRAKE]: '急刹：减速度<-2.4m/s2',
  [TestMethod.JERK]: '顿挫：速度间隔有为0~5秒内频繁加减速，频率2次以上',
  [TestMethod.COLLISION]: '碰撞：系统评测',
  [TestMethod.DRIFT]: '画龙：系统评测',
  [TestMethod.SLOPE_START]: '坡起：系统评测，前进速度为负值，则为溜坡',
  [TestMethod.RUN_RED_LIGHT]: '闯红灯：系统评测',
};

export const ReportTypeText: Record<ReportType, string> = {
  [ReportType.SYSTEM]: '系统触发',
  [ReportType.MANUAL]: '手动触发',
};

export const OperationTypeText: Record<OperationType, string> = {
  [OperationType.CREATE]: '创建',
  [OperationType.PAUSE]: '暂停',
  [OperationType.RESUME]: '恢复',
  [OperationType.FINISH_VOID]: '结束并作废',
  [OperationType.SAVE_EVAL]: '保存测评',
  [OperationType.SUBMIT_EVAL]: '提交测评',
  [OperationType.SYSTEM_EVAL]: '系统测评',
  [OperationType.UPDATE_EVAL]: '更新测评',
  [OperationType.RETEST]: '重测',
};
